export default __webpack_public_path__ + "static/media/multi.b7113201.jpg";